import React, { useState, useEffect } from "react";
import { Table, Input } from "reactstrap";
import CircularProgress from "../../../CircularProgress/CircularProgress";
import style from "./Grid.module.scss";
import * as ItemUI from "./../../../../components/Custody/Items";
import { Numeric } from "../../Order/Field/Field";
import Account from "../Items/Account";
import { Button } from "reactstrap";
import translate from "../../../../utils/Translator";

const Grid = ({
  account,
  propia,
  readOnly,
  addCustody,
  removeCustody,
  actions,
  fetchs,
  fetchSearchAccount,
  onChange,
  isFundsXSystem = false,
}) => {
  let debit = 0;
  if (account !== undefined && account.length !== 0) {
    if (!readOnly) debit = account[0].Coldebit + 1;
    else debit = account[0].Coldebit;
  }

  return (
    <div className={`content ${style.desk}`}>
      {!readOnly && (
        <Button
          outline
          color="primary"
          size="sm"
          onClick={() => addCustody(account, propia, "Customer")}
          className={style.iconBtn}
        >
          <i className="fa fa-plus-circle"></i>
        </Button>
      )}

      <Table className={style.table} striped>
        <thead>
          {propia ? (
            <tr>
              <th>{isFundsXSystem ? "Funds" : "Prop Clients"}</th>
              <th></th>
              <th></th>
              <th colSpan={String(debit)} style={{ color: "red" }}>
                Debit
              </th>
              <th style={{ color: "blue" }}>Credit</th>
              <th></th>
              <th></th>
            </tr>
          ) : (
            <tr>
              <th>Clients</th>
              <th></th>
              <th></th>
              <th colSpan={String(debit)} style={{ color: "red" }}>
                Debit
              </th>
              <th style={{ color: "blue" }}>Credit</th>
              <th></th>
              <th></th>
            </tr>
          )}
          <tr>
            <th>{translate("Account")}</th>
            <th>Balance Type</th>
            <th>Portfolio</th>
            {account == null ? (
              <th></th>
            ) : account.length == 0 ? (
              <th></th>
            ) : account[0].Coldebit == 0 ? (
              <th></th>
            ) : (
              account[0].FootPrintDebit.map((d, j) => (
                // <tr key={`c-${d.EventAccountFootPrintId}`}>
                <th>{`${d.Tooltip}`}</th>
                //  <td>{`${d.Tooltip}`}</td>

                //</tr>
              ))
            )}
            {account == null ? (
              <th></th>
            ) : account.length == 0 ? (
              <th></th>
            ) : account[0].Colcredit == 0 ? (
              <th></th>
            ) : (
              account[0].FootPrintCredit.map((d, j) => (
                // <tr key={`c-${d.EventAccountFootPrintId}`}>
                <th>{`${d.Tooltip}`}</th>
                //  <td>{`${d.Tooltip}`}</td>

                //</tr>
              ))
            )}
          </tr>
          {!readOnly && <th></th>}
        </thead>
        <tbody>
          {account == null ? (
            <EmptyTable loading={true} pro={propia} />
          ) : account.length == 0 ? (
            <EmptyTable pro={propia} />
          ) : (
            account.map((c, i) => {
              const isCustodyBalanceType = c.EventBalanceType.trim().toLowerCase() === 'custody';
              return (
                <tr key={`c-${i}`}>
                  <td style={{ paddingBottom: "20px" }}>
                    <Account
                      AccountId={c.BasicAccountId}
                      AccountName={c.BasicAccountName}
                      AccountNumber={c.BasicAccountNumber}
                      onChange={(v) => onChange("Account", "Client", propia, i, 0, v)}
                      filter={[]}
                      hideInstruction={true}
                      hideHolder={true}
                      custody={false}
                      readonly={{
                        AccountName: readOnly,
                      }}
                      errors={
                        {
                          // AccountName: '',
                          // AccountNumber: 0,
                        }
                      }
                      services={{
                        fetchSearchAccount: fetchSearchAccount,
                      }}
                    />
                  </td>
                  <td>{c.EventBalanceType}</td>
                  <td>
                    <Numeric
                      readOnly={isCustodyBalanceType ? isCustodyBalanceType : readOnly}
                      value={c.EventAccountAmount}
                      onChange={(v) => onChange("EventAccountAmount", "Client", propia, i, 0, v)}
                      dataTypeDecimalName="currency"
                    />
                  </td>
                  {c.Coldebit == 0 ? (
                    <div></div>
                  ) : (
                    c.FootPrintDebit.map((d, j) => (
                      // <tr key={`c-${d.EventAccountFootPrintId}`}>
                      <td>
                        <Numeric
                          readOnly={isCustodyBalanceType ? isCustodyBalanceType : d.EventAccountIsTax && readOnly}
                          style={{ color: "Red" }}
                          value={d.EventAccountDebitCreditVolume}
                          onChange={(v) => onChange("Debit", "Client", propia, i, j, v)}
                          dataTypeDecimalName="currency"
                        />
                      </td>
                    ))
                  )}
                  {c.Colcredit == 0 ? (
                    <div></div>
                  ) : (
                    c.FootPrintCredit.map((d, j) => (
                      <td>
                        <Numeric
                          readOnly={isCustodyBalanceType ? isCustodyBalanceType : d.EventAccountIsTax && readOnly}
                          style={{ color: "Blue" }}
                          value={d.EventAccountDebitCreditVolume}
                          onChange={(v) => onChange("Credit", "Client", propia, i, j, v)}
                          dataTypeDecimalName="currency"
                        />
                      </td>
                    ))
                  )}
                  {!readOnly && (
                    <td>
                      <Button
                        outline
                        color="primary"
                        size="sm"
                        onClick={() => removeCustody(account, propia, "Customer", i, c.BasicAccountId)}
                        className={style.iconBtn}
                      >
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </Button>
                    </td>
                  )}
                </tr>
              )
            })
          )}
        </tbody>
      </Table>
    </div>
  );
};

const EmptyTable = ({ loading, pro }) => (
  <tr>
    <td colSpan="10" style={{ textAlign: "center", padding: "60px" }}>
      {loading ? (
        <CircularProgress style={{ marginTop: "10%" }} />
      ) : (
        <div>
          {pro ? (
            <h4 style={{ textAlign: "center" }}>No Prop Clients</h4>
          ) : (
            <h4 style={{ textAlign: "center" }}>No Clients</h4>
          )}
        </div>
      )}
    </td>
  </tr>
);

export default Grid;
